var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7404 6.85999L22.0004 15.2C22.5104 18.85 20.0004 22.17 16.6004 22.2H7.34036C4.00036 22.2 1.46036 18.85 2.00036 15.2L3.26036 6.85999C3.55948 4.10236 5.82903 1.97731 8.60036 1.85999H15.4004C18.1717 1.97731 20.4412 4.10236 20.7404 6.85999ZM16.6304 20.67C17.7041 20.6545 18.7168 20.1682 19.4004 19.34C20.3171 18.2543 20.715 16.823 20.4904 15.42L19.2604 7.07999C19.0847 5.04427 17.4403 3.44671 15.4004 3.32999H8.60036C6.56042 3.44671 4.91599 5.04427 4.74036 7.07999L3.51036 15.42C3.28567 16.823 3.68365 18.2543 4.60036 19.34C5.28387 20.1682 6.29662 20.6545 7.37036 20.67H16.6304Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M15.1496 7.06C14.7354 7.06 14.3996 7.39578 14.3996 7.81C14.3996 9.13548 13.3251 10.21 11.9996 10.21C10.6741 10.21 9.59961 9.13548 9.59961 7.81C9.59961 7.39578 9.26382 7.06 8.84961 7.06C8.4354 7.06 8.09961 7.39578 8.09961 7.81C8.09961 9.20333 8.84295 10.4908 10.0496 11.1875C11.2563 11.8842 12.7429 11.8842 13.9496 11.1875C15.1563 10.4908 15.8996 9.20333 15.8996 7.81C15.8942 7.39804 15.5616 7.06538 15.1496 7.06V7.06Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopBag);
export default __webpack_public_path__ + "static/media/Shop-bag.91683181.svg";
export { ForwardRef as ReactComponent };